import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { TDocumentDefinitions } from "pdfmake/interfaces";
import { QRCodeSVG } from "qrcode.react";
import ReactDOMServer from "react-dom/server";

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

function getBase64Image(img: Blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(img);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

function rotateImage(base64: any, angleDeg: any) {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const angle = angleDeg * (Math.PI / 120);

      canvas.width = img.height;
      canvas.height = img.width;

      ctx?.translate(canvas.width / 2, canvas.height / 2);
      ctx?.rotate(angle);
      ctx?.drawImage(img, -img.width / 2, -img.height / 2);

      resolve(canvas.toDataURL());
    };
  });
}

const RelatorioImportPDF = async (dados: { produtos: any; paisOrigem: any; }) => {
  console.log(dados.paisOrigem)
  const today = new Date();
  const dia = today.getDate();
  const mes = today.toLocaleString("pt-BR", { month: "long" });
  const ano = today.getFullYear();

  const imageBlob = await fetch("/img/logo/InsigniaAngola.png").then((res) =>
    res.blob()
  );
  const imageBase64 = (await getBase64Image(imageBlob)) as string;
  const imageConvert = await fetch("/img/logo/logoArmed.png").then((res) =>
    res.blob()
  );
  const imageArmed = (await getBase64Image(imageConvert)) as string;
  const imageAgtpng = await fetch("/img/logo/AGT.png").then((res) =>
    res.blob()
  );
  const agetpicture = (await getBase64Image(imageAgtpng)) as string;
  const rotatedImage = await rotateImage(imageArmed, -45);

  // const qrCodeSVG = ReactDOMServer.renderToStaticMarkup(
  //   <QRCodeSVG
  //     value={`https://armed.gov.ao/verifica-estabelecimento/${dados?.importador?._id}`}
  //     type="svg"
  //   />
  // );

  // const numeroCompleto = dados?.declaracao?.numeroDeclaracao || "";
  // const [numeroDeclaracao, anoDeclarao] = numeroCompleto.split("/");

  // function gararTabelaProdutos() {
  //   const table = {
  //     headerRows: 1,
  //     widths: ['*', '*'],
  //     body: [
  //       [
  //         { text: 'PRODUTOS MAIS IMPORTADOS', style: 'cabecalho', colSpan: 2 }, {}
  //       ],
  //       [
  //         { text: 'Quantidade Importada', style: 'cabecalho' },
  //         { text: 'Produto', style: 'cabecalho' },
  //       ],
  //       ...dados?.produtos.map((produto: any) => [
  //         { text: `${produto?.quantidade ?? '-'}`, style: 'body' },
  //         { text: `${produto?.nome ?? '-'}`, style: 'body', },
  //       ]),
  //     ],
  //   };
  //   return table;
  // }

  // [
  //   { text: 'PRODUTOS MAIS IMPORTADOS', style: 'cabecalhoTitulo', colSpan: 2, alignment: 'center' },
  //   {}
  // ],

  function gerarTabelaProdutos() {
    const table = {
      headerRows: 2,
      widths: ['30%', '70%'],
      // layout: 'lightHorizontalLines',
      layout: 'grid',
      body: [

        [
          { text: 'Quantidade Importada', style: 'cabecalho', alignment: 'center' },
          { text: 'Produto', style: 'cabecalho', alignment: 'center' },
        ],
        ...dados?.produtos.map((produto: any) => [
          { text: `${produto?.quantidade ?? '-'}`, style: 'body', alignment: 'center' },
          { text: `${produto?.nome ?? '-'}`, style: 'body', alignment: 'left' },
        ]),
      ],
    };

    return table;
  }


  function gararTabelaPaisOrigem() {
    const table = {
      headerRows: 1,
      widths: ['*', '*'],
      body: [
        [
          { text: 'EXPORTAÇÃO POR PAÍS DE ORIGEM', style: 'cabecalho', colSpan: 2 }, {}
        ],
        [
          { text: 'Nº de solicitaçōes', style: 'cabecalho' },
          { text: 'Origem', style: 'cabecalho' },
        ],
        ...dados?.paisOrigem.map((pais: any) => [
          { text: `${pais?.solicitacoes ?? '-'}`, style: 'body' },
          { text: `${pais?.nome ?? '-'}`, style: 'body', },
        ]),
      ],
    };
    return table;
  }

  function gararTabelaPontoEntrada() {
    const table = {
      headerRows: 1,
      widths: ['*', '*'],
      body: [
        [
          { text: 'SOLICITAÇŌES POR PONTO DE ENTRADA', style: 'cabecalho', colSpan: 2 }, {}
        ],
        [
          { text: 'Nº de solicitaçōes', style: 'cabecalho' },
          { text: 'Origem', style: 'cabecalho' },
        ],
        ...dados?.paisOrigem.map((pais: any) => [
          { text: `${pais?.solicitacoes ?? '-'}`, style: 'body' },
          { text: `${pais?.nome ?? '-'}`, style: 'body', },
        ]),
      ],
    };
    return table;
  }


  const docDefinition: TDocumentDefinitions = {
    pageSize: "A4",
    pageMargins: [45, 10, 45, 100],

    content: [
      {
        columns: [
          {
            stack: [
              // {
              //   svg: qrCodeSVG,
              //   width: 55,
              //   height: 55,
              //   margin: [0, 0, 0, 0],
              // },
            ],
            alignment: "left",
            style: "header",
          },
          {
            image: imageBase64 as string,
            width: 80,
            height: 80,
            alignment: "center",
          },
          {
            text: "",
            width: "43%",
          },

        ],
        margin: [0, 40, 0, 5],
      },
      /** TITULO E SUBTITULO **/
      { text: "REPÚBLICA DE ANGOLA", style: "header" },
      { text: "MINISTÉRIO DA SAÚDE", style: "header" },
      {
        text: "AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE",
        style: "header",
      },
      //${new Date(dados?.dataDespacho).getFullYear()}
      {
        text: [
          `RELATÓRIO DE IMPORTAÇÃO E DESALFANDEGAMENTO`,
          {
            text: ``,
            bold: true,
            // decoration: "underline",
          },
        ],
        style: "header",
        margin: [0, 10, 0, 10],
      },

      { table: gerarTabelaProdutos(), layout: 'headerLineOnly' },
      { text: '', fontSize: 14, margin: [0, 3, 0, 3], },
      { table: gararTabelaPaisOrigem(), layout: 'headerLineOnly' },
      { text: '', fontSize: 14, margin: [0, 3, 0, 3], },


      {
        text: [
          `GABINETE DO DIRECTOR GERAL DA AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE, EM LUANDA, AOS `,
          { text: `${dia}`, bold: true },
          ` DE `,
          { text: `${mes.toUpperCase()}`, bold: true },
          ` DE `,
          { text: `${ano}`, bold: true },
          `.`,
        ],
        alignment: "left",
        style: "header",
      },
      {
        text: "A DIRECÇÃO",
        alignment: "center",
        style: "signature",
        margin: [0, 10, 0, 10],
      },
      {
        text: "MARIA JÚLIA GABRIELA SIMÃO",
        alignment: "center",
        style: "signature",
      },

    ],
  
    // Adiciona o rodapé
    footer: () => {
      return [
        {
          text: "____________________________________________________________________________________________________",
          style: "",
          margin: [0, 0, 0, 0],
          bold: true,
          alignment: "center",
        },
        {
          columns: [
            {
              stack: [
                {
                  text: "Rua Cmdt. Che Guevara nº 6/86º Bº Maculusso, Ingombota",
                  style: "",
                  margin: [0, 10, 0, 0],
                  bold: true,
                },
                {
                  text: "Tel.: +244 938 120 372",
                  style: "",
                  margin: [0, 0, 0, 0],
                  bold: true,
                },
                {
                  text: "Email: geral@armed.minsa.gov.ao LUANDA-ANGOLA",
                  style: "",
                  margin: [0, 0, 0, 0],
                  bold: true,
                },
              ],
              width: "70%",
              fontSize: 9,
              alignment: "left",
            },
            {
              width: "30%",

              stack: [
                {
                  image: imageArmed as string,
                  width: 150,
                  height: 50,
                  alignment: "center" as "center",
                },
              ],
            },
          ],
          alignment: "center",
          fontSize: 8,
          margin: [50, 0, 50, 0],
        },
      ];
    },

    // background: function (currentPage, pageSize) {
    //   return {
    //     image: rotatedImage as string,
    //     width: 300,
    //     height: 600,
    //     opacity: 0.1,
    //     alignment: "center",
    //     margin: [0, 60, 0, 0],
    //   };
    // },
    images: {
      mySuperImage: `data:image/jpeg;base64,/${imageBase64}`,
      // in browser is supported loading images via url (https or http protocol) (minimal version: 0.1.67)
      snow: "/img/logo/logoArmed.png",
      // is supported loading images via url with custom headers (minimal version: 0.2.5)
      strawberries: {
        url: "/img/logo/logoArmed.png",
        headers: {
          myheader: "123",
          myotherheader: "abc",
        },
      },
    } as Record<string, any>,

    /** ESTILOS DE DOCUMENTO **/
    styles: {
      header: {
        fontSize: 11,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 0],
      },
      subheader: {
        fontSize: 12,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 0],
        decoration: "underline",
      },
      declaration: {
        fontSize: 12,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 0],
        decoration: "underline",
      },
      body: {
        fontSize: 11,
        alignment: "justify",
        margin: [0, 0, 0, 10],
        lineHeight: 1.3,
      },
      signature: {
        fontSize: 11,
        bold: true,
        margin: [0, 10, 0, 0],
      },
      cabecalhoTitulo: {
        bold: true,
        fontSize: 13,
        margin: [0, 5, 0, 5],
      },
      cabecalho: {
        bold: true,
        fontSize: 11,
        fillColor: '#eeeeee',
        margin: [0, 4, 0, 4],
      },

    },
    defaultStyle: {
      font: "Roboto",
    },
  };

  pdfMake.createPdf(docDefinition).open();
};

export { RelatorioImportPDF };
